import Parse from 'parse';

// Initialize Parse with your Parse Server settings
Parse.initialize('myAppId'); // App ID
Parse.serverURL = 'https://forms.bethelchristiancenter.com/api/parse'; // Server URL

// Create a separate Parse configuration for the Bethel app server
// We'll use the global Parse object but switch contexts when needed
export const BethelAppParse = {
    ...Parse,
    _originalServerURL: Parse.serverURL,
    _originalAppId: Parse._applicationId,
    
    // Override methods to use Bethel app server
    Cloud: {
        run: async (name, data, options) => {
            const originalServerURL = Parse.serverURL;
            const originalAppId = Parse.applicationId;
            
            try {
                Parse.serverURL = 'https://app.bethelchristiancenter.com/parse';
                Parse._initialize('bethel', null, null);
                return await Parse.Cloud.run(name, data, options);
            } finally {
                Parse.serverURL = originalServerURL;
                Parse._initialize(originalAppId, null, null);
            }
        }
    },
    
    Query: class extends Parse.Query {
        constructor(className) {
            Parse.serverURL = 'https://app.bethelchristiancenter.com/parse';
            Parse._initialize('bethel', null, null);
            super(className);
        }
    },
    
    Object: Parse.Object,
    User: Parse.User,
    File: Parse.File
};

// Keep the existing API endpoints for non-form functionality
const BASE_URL = 'http://localhost:3001';

export const API = {
    accounts: {
        list: () => `${BASE_URL}/accounts`,
        create: () => `${BASE_URL}/accounts`,
        update: (id) => `${BASE_URL}/accounts/${id}`,
        delete: (id) => `${BASE_URL}/accounts/${id}`,
    },
    vendors: {
        list: () => `${BASE_URL}/vendors`,
        create: () => `${BASE_URL}/vendors`,
        update: (id) => `${BASE_URL}/vendors/${id}`,
        delete: (id) => `${BASE_URL}/vendors/${id}`,
        uploadW9: (id) => `${BASE_URL}/vendors/${id}/documents/w9`,
        uploadInsurance: (id) => `${BASE_URL}/vendors/${id}/documents/insurance`,
    },
    purchaseOrders: {
        list: () => `${BASE_URL}/purchase-orders`,
        create: () => `${BASE_URL}/purchase-orders`,
        update: (id) => `${BASE_URL}/purchase-orders/${id}`,
        delete: (id) => `${BASE_URL}/purchase-orders/${id}`,
        approve: (id) => `${BASE_URL}/purchase-orders/${id}/approve`,
        uploadLineItemAttachment: (poId, lineItemId) =>
            `${BASE_URL}/purchase-orders/${poId}/line-items/${lineItemId}/attachment`,
    }
};

// Define Parse SDK classes for forms
export const ParseClasses = {
    Form: 'Form',
    CampusLockUp: 'CampusLockUp',
    EquipmentRequest: 'EquipmentRequest',
    PlatformChangeRequest: 'PlatformChangeRequest',
    LiveServicesTechRequest: 'LiveServicesTechRequest',
    PerformingArtsTechRequest: 'PerformingArtsTechRequest',
    SaveTheDate: 'SaveTheDate', // New class for Save the Date requests
    JobApplication: 'JobApplication' // Class for job applications
};

// Define Parse SDK classes for Bethel app (Pastor's Tools)
export const BethelAppClasses = {
    User: '_User',
    UserFormRelationship: 'UserFormRelationship',
    Bulletin: 'Bulletin',
    GivingType: 'GivingType',
    Payment: 'Payment',
    PrayerRequest: 'PrayerRequest'
};

// Email-based authentication verification for Pastor's Tools
export const verifyPastoralAccess = async (userEmail) => {
    try {
        // Save current Parse configuration
        const originalServerURL = Parse.serverURL;
        const originalAppId = Parse.applicationId;
        
        // Switch to Bethel app server
        Parse.serverURL = 'https://app.bethelchristiancenter.com/parse';
        Parse._initialize('bethel', null, null);
        
        // Use cloud function to verify pastoral access (bypasses ACL with master key)
        const result = await Parse.Cloud.run('verifyPastoralAccess', { email: userEmail });
        
        // Restore original Parse configuration
        Parse.serverURL = originalServerURL;
        Parse._initialize(originalAppId, null, null);
        
        return {
            hasAccess: result.hasAccess,
            user: result.user ? {
                email: userEmail, // Keep the email from the original request
                firstName: result.user.firstName,
                lastName: result.user.lastName,
                pastoralTeam: true // If we got here, they have pastoral team access
            } : null
        };
    } catch (err) {
        // Restore original Parse configuration on error
        console.error('Error verifying pastoral access:', err);
        
        return {
            hasAccess: false,
            user: null,
            error: err.message
        };
    }
};

export default Parse;